import { useContext } from 'react'
import { WalletControllerContext } from 'pages/Wallets/context/WalletProvider'

export const useWalletControllerContext = () => useContext(WalletControllerContext)
